import { render, staticRenderFns } from "./AppResourcesPanel.vue?vue&type=template&id=6836c4f6&scoped=true&"
import script from "./AppResourcesPanel.vue?vue&type=script&lang=js&"
export * from "./AppResourcesPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppResourcesPanel.vue?vue&type=style&index=0&id=6836c4f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6836c4f6",
  null
  
)

export default component.exports